// Staging

// export const baseUrl = "https://fikrfree.ecnstg.com/api/";

// Production

// export const baseUrl = "https://fikrfree.com.pk/api/";

export const baseUrl = "http://demo.fikrfree.com.pk";

export const username = "jazzfikrfreeMAPP";

export const password = "In108ze64F1CwhgpuliqB5n";

export const gtmId = "GTM-TDH75CXP";

export const imageUrl = `https://fikrfree.com.pk/`;

export const JazzCashRedirectUrl =
  "http://jazzgameworld.com.pk/jcms/link-wallet";
